import { Children, isValidElement } from 'react';
function sortChildrenByPropName(children, propName, order) {
    const sort = (childA, childB) => {
        if (isValidElement(childA) && isValidElement(childB)) {
            const propA = childA.props[propName];
            const propB = childB.props[propName];
            if (order) {
                return order.indexOf(propA) - order.indexOf(propB);
            }
            const hasA = !isNaN(propA);
            const hasB = !isNaN(propB);
            return (Number(hasB) - Number(hasA)) || (hasA && propA - propB) || 0;
        }
        return 0;
    };
    return Children.toArray(children).sort(sort);
}
export { sortChildrenByPropName, };
//# sourceMappingURL=sort-children-by-prop-name.js.map